import { BOOKING_CHANGE_SCHEDULE } from "../actions/types";

export default (changeSchedule = {}, action) => {
    if (action.type === BOOKING_CHANGE_SCHEDULE) {
        return action.payload;
    }
    return changeSchedule;
};
